module.exports = __webpack_public_path__ + "cross-platform-development.1TgyN8AS.svg";